// react-icons
import {
  IoMdArrowRoundBack,
  IoMdArrowRoundForward,
  IoMdMenu,
  IoLogoTwitter,
  IoIosMail,
  IoIosCheckmarkCircleOutline,
} from 'react-icons/io'
import { MdRssFeed, MdAddCircle, MdRemoveCircle } from 'react-icons/md'

// Custom Icons
import {
  ReactIcon,
  ReactColor,
  JavaScriptColor,
  NodeColor,
  ReactRouterColor,
  FirebaseColor,
} from './tech'
import { Clap } from './misc'

const icons = {
  'add-circle': MdAddCircle,
  'arrow-left': IoMdArrowRoundBack,
  'arrow-right': IoMdArrowRoundForward,
  'check-circle': IoIosCheckmarkCircleOutline,
  clap: Clap,
  email: IoIosMail,
  'firebase-color': FirebaseColor,
  'javascript-color': JavaScriptColor,
  menu: IoMdMenu,
  'node-color': NodeColor,
  react: ReactIcon,
  'react-color': ReactColor,
  'react-router-color': ReactRouterColor,
  rss: MdRssFeed,
  'subtract-circle': MdRemoveCircle,
  twitter: IoLogoTwitter,
}

export default icons
